import type { Post, Comment, DroneEvent } from "@/types";

export const CATEGORY_LIST = ["전체", "공지사항", "자유게시판", "기체정보", "비행후기", "Q&A"];
export const WRITE_CATEGORIES = ["자유게시판", "기체정보", "비행후기", "Q&A"];

export const INITIAL_POSTS: Post[] = [];

export const COMMENTS: Comment[] = [];

export const EVENTS: DroneEvent[] = [];
